import React from 'react';
import Button from '@mui/material/Button'
function UpdateIssue() {
  return <div>
      <Button>Update Issue</Button>
  </div>;
}

export default UpdateIssue;
